import React, { Fragment, Component } from "react";
import *  as loginutils from '../../Components/VideoPlayerComponent/PlayerUtils.js';
import ReactPlayer from "react-player"


export default class evsPlayer extends Component
{
    constructor(props)
    {
        super(props);
        // each player must have a random id to allow having multi player in one page
        var id = Math.floor((Math.random() * 100) + 1);
        this.state = {
            id: this.props.ID === null || this.props.ID === undefined ? id : this.props.ID,
            videoUrl: this.props.videoUrl,
            vwidth: (this.props.vwidth !== undefined ? this.props.vwidth : 640),
            vheight: (this.props.vheight !== undefined ? this.props.vheight : 360),
            vType: (this.props.vType !== undefined ? this.props.vType : "HLS"),
            mplay_url: (this.props.mplay_url !== undefined ? this.props.mplay_url : ''),
            malt_url: (this.props.malt_url !== undefined ? this.props.malt_url : ''),
            malt_title: (this.props.malt_title !== undefined ? this.props.malt_title : "Low Delay"),
            malt_type: (this.props.malt_type !== undefined ? this.props.malt_type : "websocket"),
            defaultlLbl: (this.props.defaultlLbl !== undefined ? this.props.defaultlLbl : "HLS"),
            enableDownload: (this.props.enableDownload !== undefined ? this.props.enableDownload : false),
            usewebsocket: (this.props.usewebsocket !== undefined ? this.props.usewebsocket : "false"),
            websocketurl: (this.props.websocketurl !== undefined ? this.props.websocketurl : ""),
            isSocketSSL: (this.props.isSocketSSL !== undefined ? this.props.isSocketSSL : false),
            is360Video: (this.props.is360Video !== undefined ? this.props.is360Video : false),
            CaptionSrc: (this.props.CaptionSrc !== undefined ? this.props.CaptionSrc : ""),
            isVimeo: (this.props.isVimeo !== undefined ? this.props.isVimeo : false),
            VimeoVideoID: (this.props.VimeoVideoID !== undefined ? this.props.VimeoVideoID : ""),
            auto_start: (this.props.auto_start !== undefined ? this.props.auto_start : true),
            enable_chromecast: (this.props.enable_chromecast !== undefined ? this.props.enable_chromecast : false),
            useSsl: (this.props.useSsl !== undefined ? this.props.useSsl : false),
            volume: (this.props.volume !== undefined ? this.props.volume : 0),
            loop: (this.props.loop !== undefined ? this.props.loop : 'false'),
            hide_controls: (this.props.hide_controls !== undefined ? this.props.hide_controls : false),
            skin_name: (this.props.skin_name !== undefined ? this.props.skin_name : "default"),
            vortex: null,
            start_time: this.props.StartTime !== undefined ? this.props.StartTime : 0,
            end_time: this.props.EndTime !== undefined ? this.props.EndTime : 0,
            duration: this.props.Duraion !== undefined ? this.props.Duraion : 0,
            need_current_time: this.props.NeedCurrentTime !== undefined ? this.props.NeedCurrentTime : false,
            hide_controls: this.props.HideControls !== undefined ? this.props.HideControls : false,
            clickable: this.props.Clickable !== undefined ? this.props.Clickable : true,
            //muted: (this.props.volume !== undefined && this.props.volume > 0 ? false : true),
            intVolume: this.props.intVolume !== undefined ? (this.props.volume * 100) : 50,
            onPlayVideoAction: this.props.onPlayVideoAction !== undefined ? this.props.onPlayVideoAction : null,
            onPauseVideoAction: this.props.onPauseVideoAction !== undefined ? this.props.onPauseVideoAction : null,
            hlsStartPosition: this.props.hlsStartPosition !== undefined ? this.props.hlsStartPosition : 0,
            Adsources: this.props.Adsources !== undefined ? this.props.Adsources : null,
            special_parameters: this.props.special_parameters,
            isYoutube: this.props.isYoutube !== undefined ? this.props.isYoutube : false,
        };
        this.onUrlChange = this.onUrlChange.bind(this);
        this.onVttChange = this.onVttChange.bind(this);
        this.onResizePlayer = this.onResizePlayer.bind(this);
        this.onPlayButtonClick = this.onPlayButtonClick.bind(this);
        this.onVolumeMuteChange = this.onVolumeMuteChange.bind(this);
        this.getVideoDuration = this.getVideoDuration.bind(this);
        this.getVideoCurrentTime = this.getVideoCurrentTime.bind(this);
        this.onOffessetChange = this.onOffessetChange.bind(this);
    }
    componentWillReceiveProps(nextProps)
    {
        this.setState({ vwidth: nextProps.vwidth, vheight: nextProps.vheight, CaptionSrc: nextProps.CaptionSrc });
        //if (this.state.videoUrl !== nextProps.videoUrl)
        //{
        //    this.setState({ videoUrl: nextProps.videoUrl})
        //}
    }
    onUrlChange(VideoItem)
    {
        loginutils.changeUrl(this, VideoItem);
    }
    onVttChange(CaptionSrc)
    {

        loginutils.changeVtt(this, CaptionSrc);
    }
    onResizePlayer(width, height)
    {
        loginutils.resizePlayer(this, parseInt(width), parseInt(height));
    }
    onPlayButtonClick()
    {
        loginutils.playPlayer(this);
    }
    onPauseButtonClick()
    {
        loginutils.pausePlayer(this);
    }
    onStopButtonClick()
    {
        loginutils.stopPlayer(this);
    }
    onSeekButtonClick(time)
    {
        loginutils.seekPlayer(this, time);
    }
    onChangeVolume(value)
    {
        loginutils.changeVolum(this, value);
    }
    onVolumeMuteChange(mute, volume)
    {
        loginutils.changeMute(this, mute, volume);
    }
    getVideoDuration()
    {
        return loginutils.getVideoDuration(this);
    }
    getVideoCurrentTime()
    {
        return loginutils.getCurrentTime2(this);
    }
    onOffessetChange(value)
    {
        loginutils.changeOffesstTime(this, value);
    }
    onDestroyPlayer()
    {
        loginutils.destroyPlayer(this);
    }
    onUpArrowClicked()
    {
        loginutils.on_up_arrow_clicked(this);
    }
    onDownArrowClicked()
    {
        loginutils.on_down_arrow_clicked(this);
    }
    onLeftArrowClicked()
    {
        loginutils.on_left_arrow_clicked(this);
    }

    onRightArrowClicked()
    {
        loginutils.on_right_arrow_clicked(this);
    }
    onMuteClicked()
    {
        loginutils.changeMute2(this);
    }
    onFullScreenClicked()
    {
        loginutils.on_full_screen_clicked(this);
    }
    onCLetterClicked()
    {
        loginutils.on_c_letter_clicked(this);
    }
    onSeekByKeyCodeClicked(keyCode)
    {
        loginutils.seek_player_by_key_code(this, keyCode);
    }
    componentDidMount()
    {

        loginutils.loadPlayer(this);
        if (this.state.need_current_time)
        {
            this.myInterval = setInterval(() => { loginutils.getCurrentTime(this) }, 1000)
        }
    }
    componentWillUnmount()
    {
        loginutils.destroyPlayer(this);
    }
    render()
    {
        if (this.state.isYoutube === true)
        {
            return (
                <div style={{ width: "100%", textAlign: "center" }}>
                    <ReactPlayer url={this.state.videoUrl} width={this.state.vwidth} height={this.state.vheight} style={{float:"right"}} />
                </div >
            );
        }
        else
        {
            return (
                <Fragment>
                    <div className="PLMediaVortex" id={this.state.id}  style={{ width: this.state.vwidth, height: this.state.vheight }}></div>
                </Fragment>
            );
        }
    }
}
